export default __webpack_public_path__ + "76f617bb5f6be9b5ae813b6fe20d4511.png";